import ReactDOM from "react-dom";
import IndecisionApp from "./App.js";
import "normalize.css/normalize.css";
import "./styles/styles.scss";

ReactDOM.render(<IndecisionApp />, document.getElementById("root"));
